import { isSupportTicketRouteId } from "@redotech/redo-merchant-links/links";
import { ACTIVE_CONVERSATION_QUERY_PARAMETER } from "@redotech/redo-merchant-support-app/query-parameters";
import { memo } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Redirects a deprecated support-v1 path to its support-v2 equivalent.
// Mounted on `/support/*`, outside the layout that provides team context.
export const SupportV1Redirect = memo(function SupportV1Redirect() {
  const location = useLocation();
  const params = useParams();
  const base = `/stores/${params.teamId}/support-v2`;
  const rest = params["*"] ?? "";

  if (rest === "dashboard" || rest.startsWith("dashboard/")) {
    return (
      <Navigate
        replace
        to={{
          pathname: `${base}/analytics`,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }

  const conversationId =
    new URLSearchParams(location.search).get(
      ACTIVE_CONVERSATION_QUERY_PARAMETER,
    ) || undefined;

  const target =
    conversationId && isSupportTicketRouteId(conversationId)
      ? `${base}/${conversationId}`
      : base;

  return <Navigate replace to={target} />;
});

export const SupportV2AnalyticsRedirect = memo(
  function SupportV2AnalyticsRedirect() {
    const { search, hash } = useLocation();
    const { teamId } = useParams();
    return (
      <Navigate
        replace
        to={{
          pathname: `/stores/${teamId}/support-v2/analytics`,
          search,
          hash,
        }}
      />
    );
  },
);
